import * as React from 'react';

import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  Paper,
  Typography,
} from '@mui/material';

import { useSnackbar } from 'notistack';

import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';
import useGetAlertFromLocationState from '../../core/api/hooks/common/useGetAlertFromLocationState';

import FormCard from '../../components/FormCard';
import FormPaper from '../../components/FormPaper';
import DispatchEventDrafts from './DispatchEventDrafts';
import { getColor } from '../../core/colors';
import DispatchEventList from './DispatchEventList';
import { EventFormStatus } from '../../core/api/clients';

function DispatchEventHome() {
  const { metadata, ...roles } = useAuthorizedFormData();
  const { enqueueSnackbar } = useSnackbar();

  const { message, isError, title, displayAlert } = useGetAlertFromLocationState();

  React.useEffect(() => {
    if (message && title && displayAlert) {
      enqueueSnackbar(message, { variant: isError ? 'error' : 'default' });
    }
  }, [message, isError, title, displayAlert]);

  if (!metadata) {
    return (
      <Alert severity="error">
        <AlertTitle>Error - Metadata not found</AlertTitle>
      </Alert>
    );
  }

  return (
    <React.Fragment>
      <Collapse in={roles.isContributor}>
        <FormCard
          disableAvatar
          disableLink
          color={metadata.color}
          rootRoute={metadata.route}
          title={metadata.reportType}
        >
          <Typography variant="h6" sx={{ mb: 0, color: getColor(metadata.color)[500], fontWeight: 300 }}>
            Your Drafts
          </Typography>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <DispatchEventDrafts />
          </Paper>
        </FormCard>
      </Collapse>
      <Collapse in={roles.isAdministrator || roles.isApprover || roles.isReader}>
        <FormPaper color={metadata.color}>
          <Box display="flex" alignItems="center" sx={{ mt: 1, mb: 2 }}>
            <Box display="flex" alignItems="center" flexGrow={1}>
              <Typography sx={{ mr: 2 }} variant="h5">
                Dispatch Event Forms
              </Typography>
            </Box>
          </Box>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <DispatchEventList
              statuses={[EventFormStatus.Submitted, EventFormStatus.Approved, EventFormStatus.Final]}
              pageSize={25}
              readonly={!roles.isApprover}
            />
          </Paper>
        </FormPaper>
      </Collapse>
    </React.Fragment>
  );
}

export default DispatchEventHome;
